<template>
    <!--begin::Dashboard-->
    <div class="row">
        <div
            class="col-12 aos-init aos-animate content mx-auto"
            data-aos="fade-up"
            data-aos-delay="100"
        >
            <div class="titulo-pagina mt-10 mb-10 text-lg-left text-sm-center">
                <span>FILTRO </span><span>BUSQUEDA</span>
            </div>
            <!-- <h2>búsqueda avanzada</h2> -->
            <div class="card-femsa mb-5 d-flex flex-row mb-4">
                <div
                    class="card-body row justify-content-between align-items-center py-3 px-8"
                >
                    <b-form
                        action=""
                        class="d-search"
                        @submit.stop.prevent="onSubmit"
                    >
                        <div class="row">
                            <div class="col-sm-12 col-lg-3 mt-5 mt-lg-0">
                                <label for="inputDoc" class="label-femsa mb-2"
                                    >Rut Empresa</label
                                >
                                <b-form-input
                                    class="form-control form-control-femsa"
                                    id="info-rutEmpresa"
                                    name="rutEmpresa"
                                    v-model="rutEmpresa"
                                    :state="validateState('rutEmpresa')"
                                    aria-describedby="info-rutEmpresa-mensaje-validacion"
                                    placeholder="Rut Empresa"
                                    type="text"
                                ></b-form-input>
                            </div>
                          
                            <div class="col-sm-12 col-lg-3 mt-5 mt-lg-0">
                                <label for="startDate" class="label-femsa mb-2"
                                    >Fecha Envio</label
                                >
                                <v-menu
                                    v-model="menu1"
                                    :close-on-content-click="false"
                                    max-width="290"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            :value="
                                                computedDateFormattedMomentjs
                                            "
                                            clearable
                                            class="form-control v-input-femsa"
                                            placeholder="Desde"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            @click:clear="desde = null"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="desde"
                                        @change="menu1 = false"
                                        locale="es-cl"
                                        :first-day-of-week="1"
                                    ></v-date-picker>
                                </v-menu>
                            </div>
                            <div class="col-sm-12 col-lg-3 mt-5 mt-lg-0">
                                <label
                                    for="endDate"
                                    class="label-femsa mb-7"
                                ></label>
                                <v-menu
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    max-width="290"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            :value="
                                                computedDateFormattedMomentjs2
                                            "
                                            clearable
                                            class="form-control v-input-femsa"
                                            placeholder="Hasta"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            @click:clear="hasta = null"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="hasta"
                                        @change="menu2 = false"
                                        locale="es-cl"
                                        :first-day-of-week="1"
                                    ></v-date-picker>
                                </v-menu>
                            </div>
                        </div>

                        <div class="d-flex justify-content-end mt-5">
                            <button
                                class="btn-primary-femsa col-sm offset-lg-10 offset-xl-10"
                                ref="kt_login_signin_submit"
                            >
                                Buscar
                            </button>
                        </div>
                    </b-form>
                </div>
            </div>

            <div class="titulo-pagina mt-10 mb-10 text-lg-left text-sm-center">
                <span>DOCUMENTOS </span><span>ENVIADOS</span>
            </div>
            <div
                class="d-flex flex-column flex-sm-row justify-content-end justify-content-sm-between align-items-center card-azul-femsa py-4 px-3 mb-7 "
            >
                
                <!-- <div class="checkbox mb-1 mt-1 ml-7">
                    <label class="label-azul">
                        <b-form-checkbox v-model="selectAll"
                            >Seleccionar todos</b-form-checkbox
                        >
                    </label>
                </div> -->

                <div class="d-none d-sm-block">
                    <download-excel
                        class="btn-second-femsa w-200px d-flex justify-content-center cursor-pointer "
                        :data="envioDocumentos"
                        :fields="excelEnvioDocumento"
                        worksheet="Documentos"
                        name="Documentos.xls"
                    >
                        Descargar
                    </download-excel>
                </div>

                <div class="d-block d-sm-none w-100">
                    <download-excel
                        class="btn-second-femsa w-100 d-flex justify-content-center cursor-pointer"
                        :data="envioDocumentos"
                        :fields="excelEnvioDocumento"
                        worksheet="Documentos"
                        name="Documentos.xls"
                    >
                        Descargar
                    </download-excel>
                </div>
            </div>
            <b-overlay :show="loading" varant="white" rounded="sm">
                <template
                    v-for="(item, index) in envioDocumentosLista"
                    v-show="loading == true"
                >
                    <div
                        v-bind:key="index"
                        class="card-femsa d-flex justify-content-center justify-content-md-between flex-row mb-4"
                    >
                        <!-- <div
                            class="d-flex justify-content-between align-items-center w-100 row"
                        > -->

                        <div
                            class="row justify-content-between align-items-center w-100 row-gap-20"
                        >
                            <!-- <div
                                class="col-6 col-sm-1 checkbox d-flex justify-content-center"
                            >
                                <span>
                                    <b-form-checkbox
                                        v-model="item.seleccionado"
                                    ></b-form-checkbox>
                                </span>
                            </div> -->
                            <div class="col d-none d-md-block text-center">
                                <div
                                    for="inputFn"
                                    class="card-femsa-titulo mb-4"
                                >
                                    Empresa
                                </div>
                                <span
                                    id="inputFn"
                                    class="card-femsa-sub-titulo text-center"
                                    >{{ item.razonSocial }}</span
                                >
                            </div>
                             <div class="col-6 col-sm expired">
                                <div
                                    for="inputDateLast"
                                    class="card-femsa-titulo mb-2 text-center"
                                >
                                    Fecha Envio
                                </div>
                                <span
                                    class="d-flex justify-content-center badge-femsa w-100"
                                    id="inputDateLast"
                                    :class="estiloItem(item)"
                                >
                                    {{
                                        item.fechaEnvio | formatDate
                                    }}</span
                                >
                            </div>
                            <div class="col d-none d-md-block text-center">
                                <div
                                    for="inputFn"
                                    class="card-femsa-titulo mb-4"
                                >
                                    Rut Empresa
                                </div>
                                <span
                                    id="inputFn"
                                    class="card-femsa-sub-titulo"
                                    >{{ item.rutEmpresa }}</span
                                >
                            </div>
                           
                            <div
                                class="col-6 col-sm text-center branch "
                            >
                                <div
                                    for="inputLocale"
                                    class="card-femsa-titulo mb-4"
                                >
                                    Correo Cliente
                                </div>
                                <span
                                    id="inputLocale"
                                    class="card-femsa-sub-titulo"
                                    >{{ item.correoCliente }}</span
                                >
                            </div>
                            <div
                                class="col d-none d-md-block text-center ammount"
                            >
                                <div
                                    for="inputMount"
                                    class="card-femsa-titulo mb-4"
                                >
                                    monto total
                                </div>
                                <span
                                    id="inputMount"
                                    class="card-femsa-sub-titulo"
                                    >{{ item.montoTotal | currency }}</span
                                >
                            </div>
                           <div
                                class="col d-none d-md-block text-center branch"
                            >
                                <div
                                    for="inputLocale"
                                    class="card-femsa-titulo mb-4"
                                >
                                   Estado
                                </div>
                                <span
                                    id="inputLocale"
                                    class="card-femsa-sub-titulo"
                                    >{{ item.estado }}</span
                                >
                            </div>

                             <div
                                class="col-6 col-sm text-center branch"
                            >
                                <div
                                    for="inputLocale"
                                    class="card-femsa-titulo mb-4"
                                >
                                   Detalles
                                </div>
                            
                               <button
                                class="btn-primary-femsa"
                                @click="getEnvidoDocumentoDetalles(item.envioDocumentoId)"
                            >
                               Detalles
                            </button>
                            </div>
                             <div
                                class="col-6 col-sm text-center branch" v-if="false"
                            >
                                <div
                                    for="inputLocale"
                                    class="card-femsa-titulo mb-4"
                                >
                                   Excel
                                </div>

                              <download-excel
                        class="btn-primary-femsa"
                        :data="item"
                        :fields="excelEnvioDocumentoDetalle"
                        worksheet="Detalles"
                        name="DocumentosEnviadosDetalle.xls"
                    >
                        Descargar
                    </download-excel>
                            </div>
                           
                        </div>
                    </div>
                </template>
                <!-- <v-pagination
                    v-model="page"
                    :length="Math.ceil(documents.length / perPage)"
                ></v-pagination> -->
                <!-- <div
                    class="card card-total card-row d-flex flex-row align-items-center justify-content-end mb-4"
                >
                    <label>Total a pagar</label>
                    <h4 class="m-0 pl-5">{{ totalSumm | currency }}</h4>
                </div> -->
            </b-overlay>
        </div>
			<b-modal ref="modalDetalle" id="bv-modal-example" size="xl" hide-footer>
				<template v-slot:modal-title>
				Detalle
				</template>
				<div class="d-block text-center">

					<b-overlay :show="loading" varant="white" rounded="sm">
                <template
                    v-for="(item, index) in envioDocumentoDetalles"
                    v-show="loading == true"
                >
                    <div
                        v-bind:key="index"
                        class="card-femsa d-flex justify-content-center justify-content-md-between flex-row mb-4"
                    >
                        <!-- <div
                            class="d-flex justify-content-between align-items-center w-100 row"
                        > -->

                        <div
                            class="row justify-content-between align-items-center w-100 row-gap-20"
                        >
                            <!-- <div
                                class="col-6 col-sm-1 checkbox d-flex justify-content-center"
                            >
                                <span>
                                    <b-form-checkbox
                                        v-model="item.seleccionado"
                                    ></b-form-checkbox>
                                </span>
                            </div> -->
                            <div class="col-6 col-sm text-center">
                                <div
                                    for="inputFn"
                                    class="card-femsa-titulo card-femsa-titulo-texto mb-4"
                                >
                                    N Documento
                                </div>
                                <span
                                    id="inputFn"
                                    class="card-femsa-sub-titulo text-center"
                                    >{{ item.numeroDocumento }}</span
                                >
                            </div>
                             <div class="col d-none d-md-block text-center">
                                <div
                                    for="as"
                                    class="card-femsa-titulo card-femsa-titulo-texto mb-4 "
                                >
                                    Fecha Vencimiento
                                </div>
                                <span
                                    class="card-femsa-sub-titulo"
                                    id="as"
                                >
                                    {{
                                        item.fechaVencimiento | formatDate
                                    }}</span
                                >
                            </div>
                            <div class="col d-none d-md-block text-center">
                                <div
                                    for="inputFn"
                                    class="card-femsa-titulo card-femsa-titulo-texto mb-4"
                                >
                                    Tipo Documento
                                </div>
                                <span
                                    id="inputFn"
                                    class="card-femsa-sub-titulo"
                                    >{{ item.nombreTipoDocumento }}</span
                                >
                            </div>
                           
                            <div
                                class="col-6 col-sm text-center branch"
                            >
                                <div
                                    for="inputLocale"
                                    class="card-femsa-titulo card-femsa-titulo-texto mb-2 text-center"
                                >
                                    Tipo Correo
                                </div>
                                <span
                                    id="inputLocale"
                                    class="d-flex text-nowrap badge-femsa w-100 justify-content-center"
									 :class="item.tipoCorreo === 'Vencido' ? 'vencida' : 'no-vencida'"
                                    >{{ item.tipoCorreo }}</span
                                >
                            </div>
                            <div
                                class="col d-none d-md-block text-center ammount"
                            >
                                <div
                                    for="inputMount"
                                    class="card-femsa-titulo card-femsa-titulo-texto mb-4"
                                >
                                    Monto
                                </div>
                                <span
                                    id="inputMount"
                                    class="card-femsa-sub-titulo"
                                    >{{ item.monto | currency }}</span
                                >
                            </div>
                           <div
                                class="col d-none d-md-block text-center branch"
                            >
                                <div
                                    for="inputLocale"
                                    class="card-femsa-titulo card-femsa-titulo-texto mb-4"
                                >
                                   Empresa
                                </div>
                                <span
                                    id="inputLocale"
                                    class="card-femsa-sub-titulo"
                                    >{{ item.nombreEmpresaConvenio }}</span
                                >
                            </div>

                           
                        </div>
                    </div>
                </template>

           
            </b-overlay>

				</div>
                <div class="d-flex justify-content-end">
                                                 <download-excel
                        class="btn-primary-femsa"
                        :data="envioDocumentoDetalles"
                        :fields="excelEnvioDocumentoDetalle"
                        worksheet="Detalles"
                        name="DocumentosEnviadosDetalle.xls"
                    >
                        Descargar
                    </download-excel>
				<button class="btn-primary-femsa ml-3" @click="$bvModal.hide('bv-modal-example')">Cerrar</button>
                </div>
			</b-modal>


      
    </div>

    <!--end::Dashboard-->
</template>

<script>
import { mapState } from "vuex";

import {
    GET_ENVIO_DOCUMENTOS,
    GET_ENVIO_DOCUMENTO_DETALLES,
    GET_ENVIO_DOCUMENTOS_FILTRO
} from "@/core/services/store/envioDocumento.module";

//import VueAos from 'vue-aos'
//import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
// import { Money } from "v-money";
import { validationMixin } from "vuelidate";

import { minLength } from "vuelidate/lib/validators";

import moment from "moment";
moment.locale("es");

export default {
    mixins: [validationMixin],
    name: "dashboard",
 
    data() {
        return {
            envioDocumentosLista:[],
			envioDocumentoDetalles:[],
            page: 1,
            perPage: 9999999999,
            selected: [],
            loading: true,
            menu2: false,
            menu1: false,
            rutEmpresa: null,
            hasta: null,
            desde: null,
            sucursal: "",
            codigoMedioPago: "",
            order: {},
            form: {
                rutEmpresa: null,
                desde: "",
                hasta: "",
            },
            deudaTotal: 0,
            money: {
                decimal: ",",
                thousands: ".",
                prefix: "$ ",
                suffix: "",
                precision: 0,
                masked: false,
            },

            excelEnvioDocumento: {
                'Empresa': "razonSocial",
                'Fecha Envio': "fechaEnvioFormateada",
                'Rut Empresa': "rutEmpresa",
                'Correo Cliente': "correoCliente",
                'Monto': "montoTotal",
                'Estado': "estado",
            },
            excelEnvioDocumentoDetalle: {
                'N Documento': "numeroDocumento",
                'Fecha Vencimiento': "fechaVencimientoFormateada",
                'Tipo Documento': "nombreTipoDocumento",
                'Tipo Correo': "tipoCorreo",
                'Monto': "monto",
                'Empresa': "nombreEmpresaConvenio",
            },
        };
    },
    mounted() {
        this.getEnvidoDocumentos();

    },
    validations: {
        form: {
            rutEmpresa: {
                minLength: minLength(3),
            },
            desde: {},
            hasta: {},
        },
        
    },
    methods: {

        cancelar() {
            this.selectAll = false;
        },
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
        },
        resetForm() {
            this.form = {
                rutEmpresa: null,
                desde: null,
                hasta: null,
            };

            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        onSubmit() {
            // this.$v.form.$touch();
            // if (this.$v.form.$anyError) {
            //     return;
            // }

            const rutEmpresa = this.rutEmpresa == "" ? null : this.rutEmpresa;
            const desde = this.desde;
            const hasta = this.hasta;

            // set spinner to submit button
            const submitButton = this.$refs["kt_login_signin_submit"];
            submitButton.classList.add(
                "spinner",
                "spinner-light",
                "spinner-right"
            );

            // dummy delay
            setTimeout(() => {
                // send login request
                this.getEnvidoDocumentosFiltro(
                    { rutEmpresa, desde, hasta },
                );
                submitButton.classList.remove(
                    "spinner",
                    "spinner-light",
                    "spinner-right"
                );
            }, 500);
        },
         getEnvidoDocumentosFiltro(params) {
          
            this.$Progress.start();
            this.$store
                .dispatch(GET_ENVIO_DOCUMENTOS_FILTRO,params)
                .then((response) => {
                    this.envioDocumentosLista = response
                     
                    this.$Progress.finish(), (this.loading = false);
                })
                .catch(function () {
                    this.$Progress.finish(), (this.loading = false);
                });
        },
        getEnvidoDocumentos() {

            this.$Progress.start();
            this.$store
                .dispatch(GET_ENVIO_DOCUMENTOS)
                .then((response) => {
                    this.envioDocumentosLista = response
                    this.$Progress.finish(), (this.loading = false);
                })
                .catch(function () {
                    this.$Progress.finish(), (this.loading = false);
                });
        },
        getEnvidoDocumentoDetalles(envioDocumentoId) {
            this.$Progress.start();
            this.$store
                .dispatch(GET_ENVIO_DOCUMENTO_DETALLES,envioDocumentoId)
                .then((response) => {
					 this.envioDocumentoDetalles = response
					this.$refs['modalDetalle'].show();
                    
                })
                .catch(function () {
                    this.$Progress.finish(), (this.loading = false);
                });
        },
        
       
        estiloItem(item) {
            const hoy = new Date();
            var date1 = moment(hoy).format("YYYY-MM-DD");
            var date2 = moment(item.fechaVencimiento).format("YYYY-MM-DD");
            if (moment(date1).isBefore(date2)) {
                return "no-vencida";
            } else {
                return "vencida";
            }
        },
    },
    filters: {
        formatDate(value) {
            const duration = moment(value).format("DD/MM/yyyy");
            return `${duration}`;
        },

        formatTime(value) {
            const hora = moment(value).format("HH:mm:ss");
            return `${hora}`;
        },
    },
    computed: {
        visiblePages() {
            return this.envioDocumentos.slice(
                (this.page - 1) * this.perPage,
                this.page * this.perPage
            );
        },
        selectAll: {
            get() {
                if (this.documents && this.documents.length > 0) {
                    // A users array exists with at least one item
                    let allChecked = true;

                    for (const user of this.documents) {
                        if (!this.selected.includes(user.id)) {
                            allChecked = false; // If even one is not included in array
                        }

                        // Break out of loop if mismatch already found
                        if (!allChecked) break;
                    }

                    return allChecked;
                }

                return false;
            },
            set(value) {
                if (value) {
                    // this.selected = this.documents.map((doc) => doc.id);
                    // this.documents.forEach((doc) => (doc.seleccionado = true));
                    const checked = [];
                    this.documents.forEach((item) => {
                        checked.push(item.id);
                        item.seleccionado = value;
                    });

                    this.selected = checked;
                } else {
                    this.selected = [];
                    this.documents.forEach((doc) => (doc.seleccionado = false));
                }
            },
            // set(value) {
            //     const checked = [];
            //     this.documents.forEach((item) => {
            //         checked.push(item.id);
            //         item.seleccionado = value;
            //     });

            //     this.selected = checked;
            // },
        },
        ...mapState({
            envioDocumentos: (state) => state.envioDocumento.envioDocumentos,
            errors: (state) => state.errors,
            client: (state) => state.auth.user,
           
            rutCliente: function () {
                return `${this.order.rutEmpresa}-${this.order.dvEmpresa}`;
            },
            computedDateFormattedMomentjs() {
                return this.desde
                    ? moment(this.desde).format("DD/MM/yyyy")
                    : "";
            },
            computedDateFormattedMomentjs2() {
                return this.hasta
                    ? moment(this.hasta).format("DD/MM/yyyy")
                    : "";
            },
        }),
    },
};
</script>
<style>
.custom-checkbox label {
    margin-top: 5px;
    display: block;
}
.custom-control-label::before {
    position: absolute;
    top: 0rem !important;
}
.custom-control-label::after {
    top: 0rem !important;
}
.b-form-datepicker {
    min-width: 130px;
}
.b-form-datepicker label {
    padding-bottom: 3px !important;
    padding-top: 6px;
    text-transform: none;
    white-space: nowrap !important;
    font-size: 1rem !important;
}
.b-form-datepicker .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
    padding: 10px 5px;
}
.d-content-full {
    width: 100%;
}
@keyframes float {
    0% {
        box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
        transform: translatey(0px);
    }
    50% {
        box-shadow: 0 25px 15px 0px rgba(0, 0, 0, 0.2);
        transform: translatey(-20px);
    }
    100% {
        box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
        transform: translatey(0px);
    }
}
._levitar {
    margin-top: 20px;
    animation: float 6s ease-in-out infinite;
}
.download {
    cursor: pointer;
    text-align: right;
    margin-right: 10px;
    display: table-cell;
    float: right !important;
}
.document {
    width: 80px;
}
.document-type {
    width: 90px;
}
.expired {
    width: 110px;
}
.branch {
    width: 110px;
}
.ammount {
    width: 105px;
}
.payment {
    width: 105px;
}
.input-payment {
    width: 170px;
}
.error {
    color: Red;
    font-size: 0.65em;
}
</style>
